<template>
  <div class="top">
    <div class="top_kv">
      <h1><span class="wbr">近くの人と</span><span class="wbr">気軽にチャット</span></h1>
      <p class="top_kvSubTitle"><span class="wbr">今いる場所の人と人を繋ぐ、</span><span class="wbr">チャットサービスです</span></p>
      <div class="under_arrow"></div>
    </div>
    <!-- <img src="../assets/top.jpg" class="top_img"> -->
    <div class="top_body">
      <signup/>
    </div>
  </div>
</template>

<script>
import Signup from '@/components/Signup'
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  components: {
   'signup': Signup
  },
}
</script>
<style scoped>
h1, h2 {
  font-weight: normal;
  margin: 0;
  font-weight: bold;
}

.wbr {
  display: inline-block;
  white-space: nowrap;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.top_img {
  /* position: relative;
  left: 0;
  right: 0; */
  width: 100%;
  margin-bottom: 30px;
}

.top_kv {
  background: #2b2b2b;
  color: white;
  height: 320px;
  padding: 80px 30px;
  margin-bottom: 40px;
}

.top_kvSubTitle {
  margin: 30px;
}

.top_body {
  margin-bottom: 30px;
}

.under_arrow {
  width: 20px;
  height: 20px;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  transform: rotate(45deg);
  margin: 0 auto;
  margin-top: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue